const SohoTest = () => import('../components/tests/SohoTest');
document.querySelectorAll('.test-app-js').forEach(testBlock => {
  let ids = testBlock.getAttribute('data-ids');
  new Vue({
    el: testBlock,
    template: `<SohoTest idsString="${ids}"></SohoTest>`,
    components: {SohoTest,},
  });
});

